// extracted by mini-css-extract-plugin
export var localeSelector = "_3y-0";